var xe = Object.defineProperty, Xe = Object.defineProperties;
var Ze = Object.getOwnPropertyDescriptors;
var ge = Object.getOwnPropertySymbols;
var Je = Object.prototype.hasOwnProperty, Qe = Object.prototype.propertyIsEnumerable;
var Ee = (e, t, n) => t in e ? xe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, te = (e, t) => {
  for (var n in t || (t = {}))
    Je.call(t, n) && Ee(e, n, t[n]);
  if (ge)
    for (var n of ge(t))
      Qe.call(t, n) && Ee(e, n, t[n]);
  return e;
}, ne = (e, t) => Xe(e, Ze(t));
import { create as P, getGlobalThis as Oe, isString as m, isBoolean as b, warn as ee, isArray as $, isPlainObject as D, isObject as S, isFunction as R, hasOwn as Y, format as Se, assign as x, isRegExp as Te, warnOnce as qe, isNumber as I, isEmptyObject as ie, isDate as et, sanitizeTranslatedHtml as tt, escapeHtml as Ne, inBrowser as j, mark as y, measure as z, generateCodeFrame as nt, generateFormatCacheKey as rt, isPromise as at, join as st, toDisplayString as ot } from "../../../../../@intlify_shared@11.1.12/node_modules/@intlify/shared/dist/shared.js";
import { detectHtmlTag as lt, defaultOnError as it, baseCompile as ct, createCompileError as ut, COMPILE_ERROR_CODES_EXTEND_POINT as mt } from "../../../../../@intlify_message-compiler@11.1.12/node_modules/@intlify/message-compiler/dist/message-compiler.js";
import { CompileErrorCodes as wn } from "../../../../../@intlify_message-compiler@11.1.12/node_modules/@intlify/message-compiler/dist/message-compiler.js";
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ft() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Oe().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Oe().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function B(e) {
  return S(e) && ce(e) === 0 && (Y(e, "b") || Y(e, "body"));
}
const Ie = ["b", "body"];
function _t(e) {
  return G(e, Ie);
}
const ve = ["c", "cases"];
function dt(e) {
  return G(e, ve, []);
}
const be = ["s", "static"];
function gt(e) {
  return G(e, be);
}
const Pe = ["i", "items"];
function Et(e) {
  return G(e, Pe, []);
}
const we = ["t", "type"];
function ce(e) {
  return G(e, we);
}
const ye = ["v", "value"];
function Q(e, t) {
  const n = G(e, ye);
  if (n != null)
    return n;
  throw Z(t);
}
const ke = ["m", "modifier"];
function Ot(e) {
  return G(e, ke);
}
const Ve = ["k", "key"];
function Tt(e) {
  const t = G(e, Ve);
  if (t)
    return t;
  throw Z(
    6
    /* NodeTypes.Linked */
  );
}
function G(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const a = t[r];
    if (Y(e, a) && e[a] != null)
      return e[a];
  }
  return n;
}
const Nt = [
  ...Ie,
  ...ve,
  ...be,
  ...Pe,
  ...Ve,
  ...ke,
  ...ye,
  ...we
];
function Z(e) {
  return new Error(`unhandled node type: ${e}`);
}
function re(e) {
  return (n) => pt(n, e);
}
function pt(e, t) {
  const n = _t(t);
  if (n == null)
    throw Z(
      0
      /* NodeTypes.Resource */
    );
  if (ce(n) === 1) {
    const o = dt(n);
    return e.plural(o.reduce((l, i) => [
      ...l,
      pe(e, i)
    ], []));
  } else
    return pe(e, n);
}
function pe(e, t) {
  const n = gt(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = Et(t).reduce((a, o) => [...a, oe(e, o)], []);
    return e.normalize(r);
  }
}
function oe(e, t) {
  const n = ce(t);
  switch (n) {
    case 3:
      return Q(t, n);
    case 9:
      return Q(t, n);
    case 4: {
      const r = t;
      if (Y(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (Y(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw Z(n);
    }
    case 5: {
      const r = t;
      if (Y(r, "i") && I(r.i))
        return e.interpolate(e.list(r.i));
      if (Y(r, "index") && I(r.index))
        return e.interpolate(e.list(r.index));
      throw Z(n);
    }
    case 6: {
      const r = t, a = Ot(r), o = Tt(r);
      return e.linked(oe(e, o), a ? oe(e, a) : void 0, e.type);
    }
    case 7:
      return Q(t, n);
    case 8:
      return Q(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const At = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Ct(e, t) {
  t && lt(e) && ee(Se(At, { source: e }));
}
const Mt = (e) => e;
let q = P();
function Dt(e, t = {}) {
  let n = !1;
  const r = t.onError || it;
  return t.onError = (a) => {
    n = !0, r(a);
  }, ne(te({}, ct(e, t)), { detectError: n });
}
// @__NO_SIDE_EFFECTS__
function _n(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && m(e)) {
    const n = b(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ct(e, n);
    const a = (t.onCacheKey || Mt)(e), o = q[a];
    if (o)
      return o;
    const { ast: l, detectError: i } = Dt(e, ne(te({}, t), {
      location: process.env.NODE_ENV !== "production",
      jit: !0
    })), s = re(l);
    return i ? s : q[a] = s;
  } else {
    if (process.env.NODE_ENV !== "production" && !B(e))
      return ee(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = q[n];
      return r || (q[n] = re(e));
    } else
      return re(e);
  }
}
let J = null;
function dn(e) {
  J = e;
}
function Ft(e, t, n) {
  J && J.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Rt = /* @__PURE__ */ Lt("function:translate");
function Lt(e) {
  return (t) => J && J.emit(e, t);
}
const h = {
  INVALID_ARGUMENT: mt,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, gn = 24;
function W(e) {
  return ut(e, null, process.env.NODE_ENV !== "production" ? { messages: ht } : void 0);
}
const ht = {
  [h.INVALID_ARGUMENT]: "Invalid arguments",
  [h.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [h.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [h.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [h.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [h.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [h.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function ue(e, t) {
  return t.locale != null ? Ae(t.locale) : Ae(e.locale);
}
let ae;
function Ae(e) {
  if (m(e))
    return e;
  if (R(e)) {
    if (e.resolvedOnce && ae != null)
      return ae;
    if (e.constructor.name === "Function") {
      const t = e();
      if (at(t))
        throw W(h.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return ae = t;
    } else
      throw W(h.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw W(h.NOT_SUPPORT_LOCALE_TYPE);
}
function St(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...$(t) ? t : S(t) ? Object.keys(t) : m(t) ? [t] : [n]
  ])];
}
function En(e, t, n) {
  const r = m(n) ? n : le, a = e;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let o = a.__localeChainCache.get(r);
  if (!o) {
    o = [];
    let l = [n];
    for (; $(l); )
      l = Ce(o, l, t);
    const i = $(t) || !D(t) ? t : t.default ? t.default : null;
    l = m(i) ? [i] : i, $(l) && Ce(o, l, !1), a.__localeChainCache.set(r, o);
  }
  return o;
}
function Ce(e, t, n) {
  let r = !0;
  for (let a = 0; a < t.length && b(r); a++) {
    const o = t[a];
    m(o) && (r = It(e, t[a], n));
  }
  return r;
}
function It(e, t, n) {
  let r;
  const a = t.split("-");
  do {
    const o = a.join("-");
    r = vt(e, o, n), a.splice(-1, 1);
  } while (a.length && r === !0);
  return r;
}
function vt(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const a = t.replace(/!/g, "");
    e.push(a), ($(n) || D(n)) && n[a] && (r = n[a]);
  }
  return r;
}
const K = [];
K[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
K[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
K[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
K[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
K[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
K[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
K[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const bt = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Pt(e) {
  return bt.test(e);
}
function wt(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function yt(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function kt(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Pt(t) ? wt(t) : "*" + t;
}
function Vt(e) {
  const t = [];
  let n = -1, r = 0, a = 0, o, l, i, s, u, f, E;
  const c = [];
  c[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = i : l += i;
  }, c[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (t.push(l), l = void 0);
  }, c[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    c[
      0
      /* Actions.APPEND */
    ](), a++;
  }, c[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, r = 4, c[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, l === void 0 || (l = kt(l), l === !1))
        return !1;
      c[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const F = e[n + 1];
    if (r === 5 && F === "'" || r === 6 && F === '"')
      return n++, i = "\\" + F, c[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, o = e[n], !(o === "\\" && g())) {
      if (s = yt(o), E = K[r], u = E[s] || E.l || 8, u === 8 || (r = u[0], u[1] !== void 0 && (f = c[u[1]], f && (i = o, f() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const Me = /* @__PURE__ */ new Map();
function Ut(e, t) {
  return S(e) ? e[t] : null;
}
function On(e, t) {
  if (!S(e))
    return null;
  let n = Me.get(t);
  if (n || (n = Vt(t), n && Me.set(t, n)), !n)
    return null;
  const r = n.length;
  let a = e, o = 0;
  for (; o < r; ) {
    const l = n[o];
    if (Nt.includes(l) && B(a))
      return null;
    const i = a[l];
    if (i === void 0 || R(a))
      return null;
    a = i, o++;
  }
  return a;
}
const v = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Tn = 8, Wt = {
  [v.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [v.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [v.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [v.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [v.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [v.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [v.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function H(e, ...t) {
  return Se(Wt[e], ...t);
}
const $t = "11.1.12", me = -1, le = "en-US", Ue = "", De = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Gt() {
  return {
    upper: (e, t) => t === "text" && m(e) ? e.toUpperCase() : t === "vnode" && S(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && m(e) ? e.toLowerCase() : t === "vnode" && S(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && m(e) ? De(e) : t === "vnode" && S(e) && "__v_isVNode" in e ? De(e.children) : e
  };
}
let We;
function Nn(e) {
  We = e;
}
let $e;
function pn(e) {
  $e = e;
}
let Ge;
function An(e) {
  Ge = e;
}
let Ke = null;
const Cn = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Ke = e;
}, Kt = /* @__NO_SIDE_EFFECTS__ */ () => Ke;
let Ye = null;
const Mn = (e) => {
  Ye = e;
}, Dn = () => Ye;
let Fe = 0;
function Fn(e = {}) {
  const t = R(e.onWarn) ? e.onWarn : ee, n = m(e.version) ? e.version : $t, r = m(e.locale) || R(e.locale) ? e.locale : le, a = R(r) ? le : r, o = $(e.fallbackLocale) || D(e.fallbackLocale) || m(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a, l = D(e.messages) ? e.messages : se(a), i = D(e.datetimeFormats) ? e.datetimeFormats : se(a), s = D(e.numberFormats) ? e.numberFormats : se(a), u = x(P(), e.modifiers, Gt()), f = e.pluralRules || P(), E = R(e.missing) ? e.missing : null, c = b(e.missingWarn) || Te(e.missingWarn) ? e.missingWarn : !0, g = b(e.fallbackWarn) || Te(e.fallbackWarn) ? e.fallbackWarn : !0, F = !!e.fallbackFormat, N = !!e.unresolving, M = R(e.postTranslation) ? e.postTranslation : null, O = D(e.processor) ? e.processor : null, _ = b(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter, d = R(e.messageCompiler) ? e.messageCompiler : We;
  process.env.NODE_ENV !== "production" && R(e.messageCompiler) && qe(H(v.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const p = R(e.messageResolver) ? e.messageResolver : $e || Ut, A = R(e.localeFallbacker) ? e.localeFallbacker : Ge || St, L = S(e.fallbackContext) ? e.fallbackContext : void 0, C = e, k = S(C.__datetimeFormatters) ? C.__datetimeFormatters : /* @__PURE__ */ new Map(), U = S(C.__numberFormatters) ? C.__numberFormatters : /* @__PURE__ */ new Map(), X = S(C.__meta) ? C.__meta : {};
  Fe++;
  const w = {
    version: n,
    cid: Fe,
    locale: r,
    fallbackLocale: o,
    messages: l,
    modifiers: u,
    pluralRules: f,
    missing: E,
    missingWarn: c,
    fallbackWarn: g,
    fallbackFormat: F,
    unresolving: N,
    postTranslation: M,
    processor: O,
    warnHtmlMessage: _,
    escapeParameter: T,
    messageCompiler: d,
    messageResolver: p,
    localeFallbacker: A,
    fallbackContext: L,
    onWarn: t,
    __meta: X
  };
  return w.datetimeFormats = i, w.numberFormats = s, w.__datetimeFormatters = k, w.__numberFormatters = U, process.env.NODE_ENV !== "production" && (w.__v_emitter = C.__v_emitter != null ? C.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ft(w, n, X), w;
}
const se = (e) => ({ [e]: P() });
function fe(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Yt(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function _e(e, t, n, r, a) {
  const { missing: o, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: a,
      groupId: `${a}:${t}`
    });
  }
  if (o !== null) {
    const i = o(e, n, t, a);
    return m(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Yt(r, t) && l(H(v.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Rn(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Be(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Bt(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (Be(e, t[r]))
      return !0;
  return !1;
}
const Re = typeof Intl != "undefined", He = {
  dateTimeFormat: Re && typeof Intl.DateTimeFormat != "undefined",
  numberFormat: Re && typeof Intl.NumberFormat != "undefined"
};
function Ln(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: a, onWarn: o, localeFallbacker: l } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !He.dateTimeFormat)
    return o(H(v.CANNOT_FORMAT_DATE)), Ue;
  const [s, u, f, E] = jt(...t), c = b(f.missingWarn) ? f.missingWarn : e.missingWarn, g = b(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, F = !!f.part, N = ue(e, f), M = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    N
  );
  if (!m(s) || s === "")
    return new Intl.DateTimeFormat(N, E).format(u);
  let O = {}, _, T = null, d = N, p = null;
  const A = "datetime format";
  for (let k = 0; k < M.length; k++) {
    if (_ = p = M[k], process.env.NODE_ENV !== "production" && N !== _ && fe(g, s) && o(H(v.FALLBACK_TO_DATE_FORMAT, {
      key: s,
      target: _
    })), process.env.NODE_ENV !== "production" && N !== _) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: A,
        key: s,
        from: d,
        to: p,
        groupId: `${A}:${s}`
      });
    }
    if (O = n[_] || {}, T = O[s], D(T))
      break;
    _e(e, s, _, c, A), d = p;
  }
  if (!D(T) || !m(_))
    return r ? me : s;
  let L = `${_}__${s}`;
  ie(E) || (L = `${L}__${JSON.stringify(E)}`);
  let C = i.get(L);
  return C || (C = new Intl.DateTimeFormat(_, x({}, T, E)), i.set(L, C)), F ? C.formatToParts(u) : C.format(u);
}
const Ht = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function jt(...e) {
  const [t, n, r, a] = e, o = P();
  let l = P(), i;
  if (m(t)) {
    const s = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!s)
      throw W(h.INVALID_ISO_DATE_ARGUMENT);
    const u = s[3] ? s[3].trim().startsWith("T") ? `${s[1].trim()}${s[3].trim()}` : `${s[1].trim()}T${s[3].trim()}` : s[1].trim();
    i = new Date(u);
    try {
      i.toISOString();
    } catch (f) {
      throw W(h.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (et(t)) {
    if (isNaN(t.getTime()))
      throw W(h.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (I(t))
    i = t;
  else
    throw W(h.INVALID_ARGUMENT);
  return m(n) ? o.key = n : D(n) && Object.keys(n).forEach((s) => {
    Ht.includes(s) ? l[s] = n[s] : o[s] = n[s];
  }), m(r) ? o.locale = r : D(r) && (l = r), D(a) && (l = a), [o.key || "", i, o, l];
}
function hn(e, t, n) {
  const r = e;
  for (const a in n) {
    const o = `${t}__${a}`;
    r.__datetimeFormatters.has(o) && r.__datetimeFormatters.delete(o);
  }
}
function Sn(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: a, onWarn: o, localeFallbacker: l } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !He.numberFormat)
    return o(H(v.CANNOT_FORMAT_NUMBER)), Ue;
  const [s, u, f, E] = xt(...t), c = b(f.missingWarn) ? f.missingWarn : e.missingWarn, g = b(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, F = !!f.part, N = ue(e, f), M = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    N
  );
  if (!m(s) || s === "")
    return new Intl.NumberFormat(N, E).format(u);
  let O = {}, _, T = null, d = N, p = null;
  const A = "number format";
  for (let k = 0; k < M.length; k++) {
    if (_ = p = M[k], process.env.NODE_ENV !== "production" && N !== _ && fe(g, s) && o(H(v.FALLBACK_TO_NUMBER_FORMAT, {
      key: s,
      target: _
    })), process.env.NODE_ENV !== "production" && N !== _) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: A,
        key: s,
        from: d,
        to: p,
        groupId: `${A}:${s}`
      });
    }
    if (O = n[_] || {}, T = O[s], D(T))
      break;
    _e(e, s, _, c, A), d = p;
  }
  if (!D(T) || !m(_))
    return r ? me : s;
  let L = `${_}__${s}`;
  ie(E) || (L = `${L}__${JSON.stringify(E)}`);
  let C = i.get(L);
  return C || (C = new Intl.NumberFormat(_, x({}, T, E)), i.set(L, C)), F ? C.formatToParts(u) : C.format(u);
}
const zt = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function xt(...e) {
  const [t, n, r, a] = e, o = P();
  let l = P();
  if (!I(t))
    throw W(h.INVALID_ARGUMENT);
  const i = t;
  return m(n) ? o.key = n : D(n) && Object.keys(n).forEach((s) => {
    zt.includes(s) ? l[s] = n[s] : o[s] = n[s];
  }), m(r) ? o.locale = r : D(r) && (l = r), D(a) && (l = a), [o.key || "", i, o, l];
}
function In(e, t, n) {
  const r = e;
  for (const a in n) {
    const o = `${t}__${a}`;
    r.__numberFormatters.has(o) && r.__numberFormatters.delete(o);
  }
}
const Xt = (e) => e, Zt = (e) => "", Jt = "text", Qt = (e) => e.length === 0 ? "" : st(e), qt = ot;
function Le(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function en(e) {
  const t = I(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (I(e.named.count) || I(e.named.n)) ? I(e.named.count) ? e.named.count : I(e.named.n) ? e.named.n : t : t;
}
function tn(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function nn(e = {}) {
  const t = e.locale, n = en(e), r = S(e.pluralRules) && m(t) && R(e.pluralRules[t]) ? e.pluralRules[t] : Le, a = S(e.pluralRules) && m(t) && R(e.pluralRules[t]) ? Le : void 0, o = (O) => O[r(n, O.length, a)], l = e.list || [], i = (O) => l[O], s = e.named || P();
  I(e.pluralIndex) && tn(n, s);
  const u = (O) => s[O];
  function f(O, _) {
    const T = R(e.messages) ? e.messages(O, !!_) : S(e.messages) ? e.messages[O] : !1;
    return T || (e.parent ? e.parent.message(O) : Zt);
  }
  const E = (O) => e.modifiers ? e.modifiers[O] : Xt, c = D(e.processor) && R(e.processor.normalize) ? e.processor.normalize : Qt, g = D(e.processor) && R(e.processor.interpolate) ? e.processor.interpolate : qt, F = D(e.processor) && m(e.processor.type) ? e.processor.type : Jt, M = {
    list: i,
    named: u,
    plural: o,
    linked: (O, ..._) => {
      const [T, d] = _;
      let p = "text", A = "";
      _.length === 1 ? S(T) ? (A = T.modifier || A, p = T.type || p) : m(T) && (A = T || A) : _.length === 2 && (m(T) && (A = T || A), m(d) && (p = d || p));
      const L = f(O, !0)(M), C = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        p === "vnode" && $(L) && A ? L[0] : L
      );
      return A ? E(A)(C, p) : C;
    },
    message: f,
    type: F,
    interpolate: g,
    normalize: c,
    values: x(P(), l, s)
  };
  return M;
}
const he = () => "", V = (e) => R(e);
function vn(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: a, messageCompiler: o, fallbackLocale: l, messages: i } = e, [s, u] = sn(...t), f = b(u.missingWarn) ? u.missingWarn : e.missingWarn, E = b(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, c = b(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, g = !!u.resolvedMessage, F = m(u.default) || b(u.default) ? b(u.default) ? o ? s : () => s : u.default : n ? o ? s : () => s : null, N = n || F != null && (m(F) || R(F)), M = ue(e, u);
  c && rn(u);
  let [O, _, T] = g ? [
    s,
    M,
    i[M] || P()
  ] : je(e, s, M, l, E, f), d = O, p = s;
  if (!g && !(m(d) || B(d) || V(d)) && N && (d = F, p = d), !g && (!(m(d) || B(d) || V(d)) || !m(_)))
    return a ? me : s;
  if (process.env.NODE_ENV !== "production" && m(d) && e.messageCompiler == null)
    return ee(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let A = !1;
  const L = () => {
    A = !0;
  }, C = V(d) ? d : ze(e, s, _, d, p, L);
  if (A)
    return d;
  const k = cn(e, _, T, u), U = nn(k), X = an(e, C, U);
  let w = r ? r(X, s) : X;
  if (c && m(w) && (w = tt(w)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const de = {
      timestamp: Date.now(),
      key: m(s) ? s : V(d) ? d.key : "",
      locale: _ || (V(d) ? d.locale : ""),
      format: m(d) ? d : V(d) ? d.source : "",
      message: w
    };
    de.meta = x({}, e.__meta, /* @__PURE__ */ Kt() || {}), Rt(de);
  }
  return w;
}
function rn(e) {
  $(e.list) ? e.list = e.list.map((t) => m(t) ? Ne(t) : t) : S(e.named) && Object.keys(e.named).forEach((t) => {
    m(e.named[t]) && (e.named[t] = Ne(e.named[t]));
  });
}
function je(e, t, n, r, a, o) {
  const { messages: l, onWarn: i, messageResolver: s, localeFallbacker: u } = e, f = u(e, r, n);
  let E = P(), c, g = null, F = n, N = null;
  const M = "translate";
  for (let O = 0; O < f.length; O++) {
    if (c = N = f[O], process.env.NODE_ENV !== "production" && n !== c && !Be(n, c) && fe(a, t) && i(H(v.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: c
    })), process.env.NODE_ENV !== "production" && n !== c) {
      const p = e.__v_emitter;
      p && p.emit("fallback", {
        type: M,
        key: t,
        from: F,
        to: N,
        groupId: `${M}:${t}`
      });
    }
    E = l[c] || P();
    let _ = null, T, d;
    if (process.env.NODE_ENV !== "production" && j && (_ = window.performance.now(), T = "intlify-message-resolve-start", d = "intlify-message-resolve-end", y && y(T)), (g = s(E, t)) === null && (g = E[t]), process.env.NODE_ENV !== "production" && j) {
      const p = window.performance.now(), A = e.__v_emitter;
      A && _ && g && A.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: p - _,
        groupId: `${M}:${t}`
      }), T && d && y && z && (y(d), z("intlify message resolve", T, d));
    }
    if (m(g) || B(g) || V(g))
      break;
    if (!Bt(c, f)) {
      const p = _e(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        c,
        o,
        M
      );
      p !== t && (g = p);
    }
    F = N;
  }
  return [g, c, E];
}
function ze(e, t, n, r, a, o) {
  const { messageCompiler: l, warnHtmlMessage: i } = e;
  if (V(r)) {
    const c = r;
    return c.locale = c.locale || n, c.key = c.key || t, c;
  }
  if (l == null) {
    const c = () => r;
    return c.locale = n, c.key = t, c;
  }
  let s = null, u, f;
  process.env.NODE_ENV !== "production" && j && (s = window.performance.now(), u = "intlify-message-compilation-start", f = "intlify-message-compilation-end", y && y(u));
  const E = l(r, on(e, n, a, r, i, o));
  if (process.env.NODE_ENV !== "production" && j) {
    const c = window.performance.now(), g = e.__v_emitter;
    g && s && g.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: c - s,
      groupId: `translate:${t}`
    }), u && f && y && z && (y(f), z("intlify message compilation", u, f));
  }
  return E.locale = n, E.key = t, E.source = r, E;
}
function an(e, t, n) {
  let r = null, a, o;
  process.env.NODE_ENV !== "production" && j && (r = window.performance.now(), a = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", y && y(a));
  const l = t(n);
  if (process.env.NODE_ENV !== "production" && j) {
    const i = window.performance.now(), s = e.__v_emitter;
    s && r && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - r,
      groupId: `translate:${t.key}`
    }), a && o && y && z && (y(o), z("intlify message evaluation", a, o));
  }
  return l;
}
function sn(...e) {
  const [t, n, r] = e, a = P();
  if (!m(t) && !I(t) && !V(t) && !B(t))
    throw W(h.INVALID_ARGUMENT);
  const o = I(t) ? String(t) : (V(t), t);
  return I(n) ? a.plural = n : m(n) ? a.default = n : D(n) && !ie(n) ? a.named = n : $(n) && (a.list = n), I(r) ? a.plural = r : m(r) ? a.default = r : D(r) && x(a, r), [o, a];
}
function on(e, t, n, r, a, o) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: a,
    onError: (l) => {
      if (o && o(l), process.env.NODE_ENV !== "production") {
        const i = ln(r), s = `Message compilation error: ${l.message}`, u = l.location && i && nt(i, l.location.start.offset, l.location.end.offset), f = e.__v_emitter;
        f && i && f.emit("compile-error", {
          message: i,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(u ? `${s}
${u}` : s);
      } else
        throw l;
    },
    onCacheKey: (l) => rt(t, n, l)
  };
}
function ln(e) {
  if (m(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function cn(e, t, n, r) {
  const { modifiers: a, pluralRules: o, messageResolver: l, fallbackLocale: i, fallbackWarn: s, missingWarn: u, fallbackContext: f } = e, c = {
    locale: t,
    modifiers: a,
    pluralRules: o,
    messages: (g, F) => {
      let N = l(n, g);
      if (N == null && (f || F)) {
        const [, , M] = je(
          f || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          g,
          t,
          i,
          s,
          u
        );
        N = l(M, g);
      }
      if (m(N) || B(N)) {
        let M = !1;
        const _ = ze(e, g, t, N, g, () => {
          M = !0;
        });
        return M ? he : _;
      } else
        return V(N) ? N : he;
    }
  };
  return e.processor && (c.processor = e.processor), r.list && (c.list = r.list), r.named && (c.named = r.named), I(r.plural) && (c.pluralIndex = r.plural), c;
}
ft();
export {
  Nt as AST_NODE_PROPS_KEYS,
  gn as CORE_ERROR_CODES_EXTEND_POINT,
  Tn as CORE_WARN_CODES_EXTEND_POINT,
  wn as CompileErrorCodes,
  h as CoreErrorCodes,
  v as CoreWarnCodes,
  Ht as DATETIME_FORMAT_OPTIONS_KEYS,
  le as DEFAULT_LOCALE,
  Jt as DEFAULT_MESSAGE_DATA_TYPE,
  Ue as MISSING_RESOLVE_VALUE,
  me as NOT_REOSLVED,
  zt as NUMBER_FORMAT_OPTIONS_KEYS,
  $t as VERSION,
  hn as clearDateTimeFormat,
  In as clearNumberFormat,
  _n as compile,
  ut as createCompileError,
  Fn as createCoreContext,
  W as createCoreError,
  nn as createMessageContext,
  Ln as datetime,
  En as fallbackWithLocaleChain,
  St as fallbackWithSimple,
  Kt as getAdditionalMeta,
  Dn as getFallbackContext,
  ue as getLocale,
  H as getWarnMessage,
  _e as handleMissing,
  Ft as initI18nDevTools,
  Be as isAlmostSameLocale,
  Bt as isImplicitFallback,
  B as isMessageAST,
  V as isMessageFunction,
  fe as isTranslateFallbackWarn,
  Yt as isTranslateMissingWarn,
  Sn as number,
  Vt as parse,
  jt as parseDateTimeArgs,
  xt as parseNumberArgs,
  sn as parseTranslateArgs,
  An as registerLocaleFallbacker,
  Nn as registerMessageCompiler,
  pn as registerMessageResolver,
  Ae as resolveLocale,
  On as resolveValue,
  Ut as resolveWithKeyValue,
  Cn as setAdditionalMeta,
  dn as setDevToolsHook,
  Mn as setFallbackContext,
  vn as translate,
  Rt as translateDevTools,
  Rn as updateFallbackLocale
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@intlify_core-base@11.1.12/~/@intlify/core-base/dist/core-base.js
// module id = 1301
// module chunks = 41